export default class FontConfig {
    constructor(fontFamily) {
        this.fontFamily = fontFamily;
        this.fontStyle = {
            fontFamily: this.fontFamily,
            color: "#FFFFFF",
            stroke: "#000000",
            align: "center",
            strokeThickness: 6,
            resolution: window.devicePixelRatio
        };
    }
    /**
     * Crea un nuovo TextStyle indipendente.
     * Tutti i parametri sono opzionali.
     */
    overrideFont(overrides = {}) {
        // deep clone per evitare riferimenti condivisi
        const clonedBase = typeof structuredClone === "function"
            ? structuredClone(this.fontStyle)
            : JSON.parse(JSON.stringify(this.fontStyle));
        // applica override e restituisce un nuovo oggetto
        return { ...clonedBase, ...overrides };
    }
}
